import React from 'react';
export function Card({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`rounded-xl border border-slate-100 bg-white text-slate-950 shadow-sm transition-all duration-300 ${className}`} {...props} data-id="element-269">
      {children}
    </div>;
}
export function CardHeader({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`flex flex-col space-y-1.5 p-6 ${className}`} {...props} data-id="element-270">
      {children}
    </div>;
}
export function CardTitle({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={`text-2xl font-bold leading-none tracking-tight text-slate-900 ${className}`} {...props} data-id="element-271">
      {children}
    </h3>;
}
export function CardDescription({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={`text-sm text-slate-500 leading-relaxed ${className}`} {...props} data-id="element-272">
      {children}
    </p>;
}
export function CardContent({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`p-6 pt-0 ${className}`} {...props} data-id="element-273">
      {children}
    </div>;
}
export function CardFooter({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`flex items-center p-6 pt-0 ${className}`} {...props} data-id="element-274">
      {children}
    </div>;
}